import { useMsal, useAccount } from "@azure/msal-react";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Authorized routes wrapper.
 * Unauthenticated users are sent to /login so the dedicated Microsoft
 * sign-in page remains the entry point (callback errors also land there).
 */
const AuthRoute = () => {
  const { accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  if (inProgress !== "none") {
    return <div>Signing you in…</div>;
  }

  return account ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AuthRoute;
